/**
 * 带折线
 * 
 * 胶囊图
 * 
 * 呼吸率变快
 */

import * as echarts from 'echarts';

export default function getEchartsOptionFloatA3(xAxis_data) {
	let series_data = [];
	if (xAxis_data && xAxis_data.length > 0) {
		for (let i = 0; i < xAxis_data.length; i++) {
			series_data.push(1);
		}
	}
	let option = {
		color: "#1890ff",
		grid: {
			x: 0,
			y: 5,
			x2: 0,
			y2: 13,
			containLabel: true
		},
		tooltip: {
			trigger: "axis",
			// axisPointer: {
			// type: 'shadow'
			// },
			backgroundColor: "rgba(255, 255, 255, 1)",
			borderColor: "rgba(24, 144, 255, 0.6)",
			borderWidth: 1,
			spanStyle: {
				color: "#fff",
			},
			trigger: "axis",
			confine: true,
			borderRadius: 5,
			textStyle: {
				color: '#8394B9',
				fontSize: 14
			},
			formatter: function (params) {
				return null
			},
		},
		xAxis: [
			{
				type: "category",
				data: xAxis_data,
				axisLine: {
					lineStyle: {
						color: "rgba(144, 148, 166, 0.1)",
					},
					show: false
				},
				axisLabel: {
					show: false,
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					},
				},
				axisTick: {
					show: false,
					alignWithLabel: true,
				},
				show: false,
			},
		],
		yAxis: [
			{
				type: "value",
				splitLine: {
					show: false,
				},
				axisLine: {
					lineStyle: {
						color: "#c7c6c9",
					},
					show: false,
				},
				axisLabel: {
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					},
				},
				splitNumber: 2,
				min: 1,
				max: 1,
				show: false
			},
		],
		series: [
			{
				type: "bar",
				data: series_data,
				barWidth: '100%',
				itemStyle: {
					normal: {
						color: '#FFFFFF00'
					}
				}
			}
		],
	};
	
	return option;
}